// Static site data - no database needed

export interface NavLink {
  label: string;
  href: string;
  external?: boolean;
}

export interface PortfolioItem {
  id: string;
  title: string;
  description: string;
  image: string;
  url: string;
}

export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  content?: string;
  date: string;
  category: string;
  image: string;
  slug: string;
}

export interface SkillItem {
  name: string;
  image: string;
  width: number;
  height: number;
  className: string;
}

export interface SiteSettings {
  name: string;
  tagline: string;
  title: string;
  description: string;
  phone: string;
  email: string;
  location: string;
  profileImage: string;
  aboutImage: string;
  logoImage: string;
  cvUrl: string;
  totalProjects: number;
  socialLinks: {
    facebook: string;
    instagram: string;
    whatsapp: string;
    github: string;
  };
  aboutText: string[];
}

export const siteSettings: SiteSettings = {
  name: 'Muhammad Fajrul Amin',
  tagline: 'FullStack JavaScript Developer',
  title: 'Muhammad Fajrul Amin — ReactJs Web Developer',
  description: 'fajrul.id is a front-end web developer portfolio showcasing my personal projects and blog.',
  phone: '+628-23-9092-4636',
  email: 'fajrul@fajrul.id',
  location: 'Indonesia - Rawajati/Kalibata, Kec. Pancoran, Kota Jakarta Selatan, DKI JAKARTA',
  profileImage: "https://img.rocket.new/generatedImages/rocket_gen_img_12a9d2aad-1766208117619.png",
  aboutImage: "https://img.rocket.new/generatedImages/rocket_gen_img_12a9d2aad-1766208117619.png",
  logoImage: "https://img.rocket.new/generatedImages/rocket_gen_img_12a9d2aad-1766208117619.png",
  cvUrl: '/Fajrul-Resume-1775228820959.pdf',
  totalProjects: 6,
  socialLinks: {
    facebook: 'https://www.facebook.com/frul404/',
    instagram: 'http://instagram.com/fajrul.id',
    whatsapp: 'https://wa.me/6282390924636',
    github: 'https://github.com/fajrul-id/'
  },
  aboutText: [
  "Halo! Saya Muhammad Fajrul Amin, seorang Full Stack JavaScript Developer yang lahir di Bengkulu, 30 April 2000. Saya memulai perjalanan di dunia pemrograman setelah lulus dari SMK Negeri 1 Bengkulu jurusan Teknik Komputer Jaringan, dilanjutkan dengan mengikuti Bootcamp Jvalley pada Juni 2022.",
  "Saat ini saya bekerja sebagai Full Stack Next.js Developer di PT Citracom Inti Persada (sejak Februari 2023), Jakarta Selatan, berfokus pada pengembangan aplikasi pajak untuk klien pemerintah daerah. Sebelumnya, saya juga berkontribusi sebagai Front End Developer di Yayasan Pendidikan Cerdas (Agustus–Desember 2023) di Depok.",
  "Saya berpengalaman dalam membangun aplikasi web modern menggunakan React.js, Next.js, TypeScript, serta berbagai teknologi backend seperti Express.js, Prisma, Knex.js, dan PostgreSQL. Proyek unggulan saya antara lain Smart City Muaro Jambi dan SIBIJAK Sumatera Selatan.",
  "Saat ini saya membuka peluang untuk bergabung dengan tim yang inovatif dan dinamis, baik dalam posisi Full Stack maupun Web Application Development. Saya berkomitmen menghadirkan solusi yang efisien dan berorientasi pada kebutuhan pengguna."]


};

export const navLinks: NavLink[] = [
{ label: 'Home', href: '#' },
{ label: 'Blog', href: '#blog' },
{ label: 'About', href: '#about' },
{ label: 'Skill', href: '#skill' },
{ label: 'Portfolio', href: '#portfolio' },
{ label: 'Contact', href: '#contact' }];


export const skills: SkillItem[] = [
{ name: 'html', image: 'https://fajrul-id-git-main-frul404s-projects.vercel.app/assets/img/skill/html.png', width: 200, height: 200, className: 'mx-auto mb-4 w-20 md:w-32 rounded-lg' },
{ name: 'js', image: 'https://fajrul-id-git-main-frul404s-projects.vercel.app/assets/img/skill/js.png', width: 200, height: 200, className: 'mx-auto mb-4 w-16 md:w-24 rounded-lg' },
{ name: 'css', image: "https://img.rocket.new/generatedImages/rocket_gen_img_14f243a97-1764773671449.png", width: 200, height: 200, className: 'mx-auto mb-4 w-16 md:w-24 rounded-lg' },
{ name: 'typescript', image: "https://img.rocket.new/generatedImages/rocket_gen_img_14f243a97-1764773671449.png", width: 200, height: 200, className: 'mx-auto mb-4 w-16 md:w-24 rounded-lg' },
{ name: 'node', image: "https://img.rocket.new/generatedImages/rocket_gen_img_14f243a97-1764773671449.png", width: 200, height: 200, className: 'mx-auto mb-4 w-16 md:w-24 rounded-lg' },
{ name: 'react', image: 'https://fajrul-id-git-main-frul404s-projects.vercel.app/assets/img/skill/react.png', width: 100, height: 100, className: 'mx-auto mb-4 w-16 md:h-24 rounded-lg' },
{ name: 'api', image: "https://img.rocket.new/generatedImages/rocket_gen_img_14f243a97-1764773671449.png", width: 200, height: 200, className: 'mx-auto mb-4 w-16 md:w-24 rounded-lg' },
{ name: 'express', image: "https://img.rocket.new/generatedImages/rocket_gen_img_14f243a97-1764773671449.png", width: 200, height: 200, className: 'mx-auto mb-4 w-16 md:w-24 rounded-lg' },
{ name: 'sequelize', image: 'https://fajrul-id-git-main-frul404s-projects.vercel.app/assets/img/skill/sequelize.png', width: 200, height: 200, className: 'mx-auto mb-4 w-16 md:w-20 md:h-24 rounded-lg' },
{ name: 'prisma', image: "https://img.rocket.new/generatedImages/rocket_gen_img_14f243a97-1764773671449.png", width: 200, height: 200, className: 'mx-auto mb-4 w-16 md:w-24 rounded-lg' },
{ name: 'pg', image: "https://img.rocket.new/generatedImages/rocket_gen_img_14f243a97-1764773671449.png", width: 200, height: 200, className: 'mx-auto mb-4 w-16 md:w-24 rounded-lg' },
{ name: 'figma', image: 'https://fajrul-id-git-main-frul404s-projects.vercel.app/assets/img/skill/figma.png', width: 200, height: 200, className: 'mx-auto mb-4 w-16 md:w-24 md:h-24 rounded-lg' },
{ name: 'photoshop', image: "https://img.rocket.new/generatedImages/rocket_gen_img_14f243a97-1764773671449.png", width: 200, height: 200, className: 'mx-auto mb-4 w-16 md:w-24 rounded-lg' },
{ name: 'corel', image: "https://img.rocket.new/generatedImages/rocket_gen_img_14f243a97-1764773671449.png", width: 200, height: 200, className: 'mx-auto mb-4 w-16 md:w-24 rounded-lg' }];


export const portfolioItems: PortfolioItem[] = [
{
  id: '1',
  title: 'Sistem Informasi Bina Jasa Konstruksi Sumsel (SIBIJAK)',
  description: 'Website SIBIJAK menyediakan informasi dan layanan terkait konstruksi di Sumatera Selatan, terintegrasi dengan SIPJAKI.',
  image: 'https://i.imgur.com/MqCQGb7.png',
  url: 'http://sibijaksumsel.id/'
},
{
  id: '2',
  title: 'SmartCity Muaro Jambi',
  description: 'MUji adalah platform yang mampu berinteraksi dengan masyarakat Muaro Jambi bersifat aktif dan dinamis.',
  image: 'https://i.imgur.com/xkfY64R.png',
  url: 'https://muarojambikab.go.id/'
},
{
  id: '3',
  title: 'Satu Data Muaro Jambi',
  description: 'Platform untuk pengelolaan data Muaro Jambi yang mendukung kebijakan berbasis data.',
  image: 'https://i.imgur.com/8zoLKGK.png',
  url: 'https://satudata.muarojambikab.go.id/'
},
{
  id: '4',
  title: 'Koperasi Gala Indo Mandiri',
  description: 'Website Landing Page berbasis React.js untuk menunjukkan fitur dan layanan Koperasi Gala Indo Mandiri.',
  image: 'https://i.imgur.com/7d1QTye.png',
  url: 'https://galaindo.vercel.app'
},
{
  id: '5',
  title: 'Fajrul x Tara',
  description: 'Platform undangan digital berbasis Next.js yang praktis dan interaktif.',
  image: 'https://i.imgur.com/LH6ijCN.png',
  url: 'https://tarafajrul.vercel.app'
},
{
  id: '6',
  title: 'Bidan Okti Susanti',
  description: 'Landing Page klinik untuk data pasien, jadwal, dan administrasi.',
  image: 'https://i.imgur.com/Sz1hcVo.png',
  url: 'https://bidanoktisusanti.vercel.app'
},
{
  id: '7',
  title: 'Fajrul.id Website',
  description: 'Website portfolio menggunakan React Nextjs , dan sudah terindeks Google serta support PWA',
  image: 'https://i.imgur.com/BcjX9vL.png',
  url: 'https://fajrul-id.vercel.app'
}];


export const blogPosts: BlogPost[] = [
{
  id: '1',
  title: 'Membangun Aplikasi Full Stack dengan Next.js dan PostgreSQL',
  excerpt: 'Panduan lengkap membangun aplikasi full stack modern menggunakan Next.js 14, TypeScript, dan PostgreSQL sebagai database.',
  date: '2025-01-15',
  category: 'Tutorial',
  image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=400&q=80',
  slug: 'membangun-aplikasi-fullstack-nextjs-postgresql'
},
{
  id: '2',
  title: 'Tips Optimasi Performa React.js untuk Production',
  excerpt: 'Beberapa teknik dan tips untuk mengoptimalkan performa aplikasi React.js agar lebih cepat dan efisien di production.',
  date: '2025-01-10',
  category: 'Tips',
  image: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=400&q=80',
  slug: 'tips-optimasi-performa-reactjs'
},
{
  id: '3',
  title: 'Pengenalan TypeScript untuk Developer JavaScript',
  excerpt: 'Mulai belajar TypeScript dari dasar dan pahami mengapa TypeScript menjadi pilihan utama developer modern.',
  date: '2025-01-05',
  category: 'Tutorial',
  image: 'https://images.unsplash.com/photo-1516116216624-53e697fedbea?w=400&q=80',
  slug: 'pengenalan-typescript-developer-javascript'
}];